import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService {
  getCountNotification(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`notification/unread`)
      .subscribe(
        resp => {
          // onSuccess(resp);
          if (resp.alert.code === 200) {
            onSuccess(resp);
          } else {
            onError(resp.alert);
          }
        },
        err => {
          if (onError) {
            onError(err);
          }
        }
      );
  }
  getListNotification(lim: number, off: number, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`notification?lim=${lim}&off=${off}`)
      .subscribe(
        resp => {
          // onSuccess(resp);
          if (resp.alert.code === 200) {
            onSuccess(resp);
          } else {
            onError(resp.alert);
          }
        },
        err => {
          if (onError) {
            onError(err);
          }
        }
      );
  }
  putAllNotification(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.put(`notification`)
      .subscribe(
        resp => {
          // onSuccess(resp);
          if (resp.alert.code === 200) {
            onSuccess(resp);
          } else {
            onError(resp.alert);
          }
        },
        err => {
          if (onError) {
            onError(err);
          }
        }
      );
  }
  putNotification(id: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.put(`notification/${id}`)
      .subscribe(
        resp => {
          // onSuccess(resp);
          if (resp.alert.code === 200) {
            onSuccess(resp);
          } else {
            onError(resp.alert);
          }
        },
        err => {
          if (onError) {
            onError(err);
          }
        }
      );
  }
  deleteNotification(id: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.post(`notification/delete/${id}`)
      .subscribe(
        resp => {
          // onSuccess(resp);
          if (resp.alert.code === 200) {
            onSuccess(resp);
          } else {
            onError(resp.alert);
          }
        },
        err => {
          if (onError) {
            onError(err);
          }
        }
      );
  }
  deleteAllNotification(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.post(`notification/delete`)
      .subscribe(
        resp => {
          // onSuccess(resp);
          if (resp.alert.code === 200) {
            onSuccess(resp);
          } else {
            onError(resp.alert);
          }
        },
        err => {
          if (onError) {
            onError(err);
          }
        }
      );
  }
  getDiffTimeString(dateString: string) {
    let seconds = (new Date().getTime() - Date.parse(dateString)) / 1000;
    if (seconds > 60) {
      let minutes = seconds / 60;
      if (minutes > 60) {
        let hours = minutes / 60;
        if (hours > 24) {
          let day = hours / 24;
          if (day > 30) {
            let month = day / 30;
            if (month > 12) {
              let year = month / 12;
              return (Math.round(year) + ' years ago');
            } else {
              return (Math.round(month) + ' months ago');
            }
          } else {
            return (Math.round(day) + ' days ago');
          }
        } else {
          return (Math.round(hours) + ' hours ago');
        }
      } else {
        return (Math.round(minutes) + ' minutes ago');
      }
    } else {
      return (Math.round(seconds) + ' seconds ago');
    }
  }
}
